import React, { useState, useEffect, useContext } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Button, Chip, CircularProgress, Skeleton } from '@mui/material';

import './user-lists-filter.scss';
import { setMessageUserListsFilter, setShowMessageUserLists } from '../../../redux/actions/message';
import { useHistory } from 'react-router';
import { setAlert } from '../../../redux/actions';
import { MessageContext } from './MessageContext';
import AddFilterFromModal from './AddFilterFromModal';

const LIST_PER_PAGE = 30;
const USERS_PER_PAGE = 60;
const DEBOUNCE_DELAY = 800;

const UserListsFilter = ({
    messageUserListsFilterRdx,
    onSuccess
}) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const { setNewMsgChecked } = useContext(MessageContext);

    const [busy, setBusy] = useState(false);
    const [lists, setLists] = useState([]);
    const [selectedUserLists, setSelectedUserLists] = useState([]);
    const [checking, setChecking] = useState(false);

    const getUserLists = () => {
        setBusy(true);
        axios.get('/api/user-lists/latest', {
            params: {
                limit: 5
            }
        })
            .then(response => {
                setBusy(false);
                setLists(response.data.data);
            })
            .catch(error => {
                setBusy(false);
            });
    };

    useEffect(() => {
        getUserLists();
    }, []);

    useEffect(() => {
        let ids = [];
        if (messageUserListsFilterRdx && messageUserListsFilterRdx.length > 0) {
            ids = messageUserListsFilterRdx.map(uList => uList.id);
        } else {
            ids = [];
        }
        setSelectedUserLists(ids);
    }, [messageUserListsFilterRdx]);

    const handleListClick = (list) => {
        let tmp = [...messageUserListsFilterRdx];
        const index = tmp.findIndex(t => t.id == list.id);

        if (index >= 0) {
            tmp.splice(index, 1);
        } else {
            tmp.push(list);
        }

        dispatch(setMessageUserListsFilter([...tmp]));
    };

    const handleShowLists = () => {
        dispatch(setShowMessageUserLists(true));
    };

    const goToUserLists = () => {
        history.push('/user-lists');
    };

    const handleNext = () => {
        setChecking(true);
        axios.get('/api/user-lists/check', {
            params: {
                list_ids: selectedUserLists
            }
        })
            .then(response => {
                setChecking(false);
                if (response.data.success) {
                    if (response.data.data <= 0) {
                        dispatch(setAlert({
                            show: true,
                            type: 'warning',
                            body: 'Please select a list with assigned users'
                        }));

                        return;
                    }
                    setNewMsgChecked('user_lists');
                    onSuccess(2, response.data.data);
                }
            })
            .catch(error => {
                setChecking(false);
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Failed to get user count'
                }));
            });
    };

    return <div className='user-lists-filter'>
        <div>
            <div className='user-lists-filter__header'>
                <div className='header__name'>User Lists</div>
                <div className='header__action'>
                    <Button
                        variant="text"
                        onClick={handleShowLists}
                    >View All</Button>
                </div>
            </div>

            <div className='user-lists-filter__lists'>
                {
                    lists && lists.length > 0 && lists.map((list, index) => {
                        return <Chip
                            key={list.id}
                            label={`${list.name} ${list.members_count > 0 ? list.members_count : ''}`}
                            onClick={() => handleListClick(list)}
                            color={`${selectedUserLists.includes(list.id) ? 'primary' : 'default'}`}
                        />;
                    })
                }

                {
                    !busy && lists && lists.length <= 0
                        ? <div style={{ textAlign: 'center', justifyContent: 'center' }}>
                            No user lists found. &nbsp; <Chip variant='outlined' label="Add here" onClick={goToUserLists} />
                        </div>
                        : ''
                }

                {
                    busy ? <div style={{ display: 'flex', gap: '8px' }}>
                        <Skeleton animation='wave' style={{ width: '40px' }} />
                        <Skeleton animation='wave' style={{ width: '50px' }} />
                        <Skeleton animation='wave' style={{ width: '60px' }} />
                        <Skeleton animation='wave' style={{ width: '50px' }} />
                        <Skeleton animation='wave' style={{ width: '30px' }} />
                    </div>
                        : ''
                }
            </div>

            {messageUserListsFilterRdx && messageUserListsFilterRdx.length > 0 && <div className='user-lists-filter__actions'>
                <button
                    className="btn btn-primary btn-theme"
                    onClick={handleNext}
                >Next</button>
            </div>}
        </div>
        <AddFilterFromModal />
    </div>;

};

const mapStateToProps = state => ({
    messageUserListsFilterRdx: state.message.userListsFilter
});

export default connect(mapStateToProps)(UserListsFilter);